import { CSSProperties } from 'react';
import { PositionFN } from '../types';
import { RectResult } from '../../helpers/useRect';

const getStyles = (
  setPosition: PositionFN,
  triggerRect: RectResult,
  tooltipRect: RectResult,
  position?: 'top' | 'right' | 'bottom' | 'left',
): Partial<RectResult> | CSSProperties => {
  const haventMeasuredTooltipYet = !tooltipRect;

  if (haventMeasuredTooltipYet) {
    return { visibility: 'hidden' };
  }
  return setPosition(triggerRect, tooltipRect, position);
};

export default getStyles;
